import React from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./pages/Home";
import WhatIsFrt from "./pages/WhatIsFrt";
import FrtAndCctv from "./pages/FrtAndCctv";
import NzContext from "./pages/NzContext";
import Benefits from "./pages/Benefits";
import Risks from "./pages/Risks";
import Ethics from "./pages/Ethics";
import GovernanceOptions from "./pages/GovernanceOptions";
import GovernanceOption from "./pages/GovernanceOption";
import OurResearch from "./pages/OurResearch";
import GroupProcess from "./pages/GroupProcess";
import ReferencesPage from "./pages/ReferencesPage";

function AnimatedRoutes() {
    const location = useLocation();
    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<Home />} />
                <Route path="/what-is-facial-recognition" element={<WhatIsFrt />} />
                <Route path="/frt-and-cctv" element={<FrtAndCctv />} />
                <Route path="/new-zealand-context" element={<NzContext />} />
                <Route path="/benefits" element={<Benefits />} />
                <Route path="/risks" element={<Risks />} />
                <Route path="/ethics" element={<Ethics />} />
                <Route path="/governance-options" element={<GovernanceOptions />} />
                <Route path="/governance-options/:slug" element={<GovernanceOption />} />
                <Route path="/our-research" element={<OurResearch />} />
                <Route path="/group-process" element={<GroupProcess />} />
                <Route path="/references" element={<ReferencesPage />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </AnimatePresence>
    );
}

function App() {
    React.useEffect(() => {
        const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <div className="min-h-screen bg-ink text-paper grain">
                    <Nav />
                    <main>
                        <AnimatedRoutes />
                    </main>
                    <Footer />
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
